import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ChartType, GoogleChartsModule } from 'angular-google-charts';

@Component({
  selector: 'controls-bo-gaugechart',
  imports: [CommonModule, GoogleChartsModule],
  templateUrl: './bo-gaugechart.component.html',
  styleUrls: ['./bo-gaugechart.component.scss']
})
export class BoGaugechartComponent implements OnInit {
  @Input() chartForm: FormGroup | any;
  chartType = ChartType.Gauge;

  myData = [
    ['Value', 87]
  ];
  options = {
    // height: '230',
    // width: '300',
    redFrom: 10, redTo: 30,
    yellowFrom: 30, yellowTo: 50,
    greenFrom: 50, greenTo: 90,
    // redFrom: 75, redTo: 100,
    // yellowFrom: 55, yellowTo: 90,
    minorTicks: 5,
    majorTicks: ['0%', '100%'],
    title: '',
    legend: { position: 'bottom' }
  }
  cStyle: any = {};

  constructor() { }

  ngOnInit(): void {
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
    }
  }

}
